const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
export const HOST =
  currentEnv !== 'prod'
    ? 'https://layer.qa.col.movistar.es'
    : 'https://layer.col.movistar.es';

export const FAMILY_API = 'abs-layer';
export const PROCESS_NAME = 'ADABYRON-API';
